import { type EnumFrontendLayoutSetting } from '@Model';
import { useTableLayoutFromSettings } from '@Hooks/index';
import { Table, type IId, type ITableProperties } from '@synqo/frontend-component-library';

export interface TableWithLayoutSettingsProps<TItem extends IId> extends ITableProperties<TItem> {
    layoutSettingsContext: EnumFrontendLayoutSetting;
}

export function TableWithLayoutSettings<TItem extends IId>({
    layoutSettingsContext,
    ...props
}: TableWithLayoutSettingsProps<TItem>) {
    const { columnSizing, columnVisibility, updateSizing, updateVisibility } = useTableLayoutFromSettings(
        layoutSettingsContext,
        props.columns,
    );

    return (
        <Table
            columnSizing={columnSizing}
            columnVisibility={columnVisibility}
            onSizesChange={updateSizing}
            onVisibilityChange={updateVisibility}
            {...props}
        />
    );
}
